import React, { useState } from 'react';
import MetaDataTop         from '../../../components/postBlog/metaDataTop';
import Wysiwyg             from '../../../components/postBlog/wysiwyg';
import MetaDataDown        from '../../../components/postBlog/metaDataDown';
import Button              from '@mui/material/Button';
import Grid                from '@mui/material/Grid';
import draftToHtml         from "draftjs-to-html";
import { convertToRaw }    from "draft-js";
import { articleAdd }      from '../../../apis/article';

const initialState = {
    url        : "",
    urlRegex   : false,
    status     : "draft",
    title      : "",
    desc       : "",
    shortDesc  : "",
	editorState: null,
	seoTitle   : "",
	seoDesc    : "",
	tags       : [],
	imgAlt     : "",
	img        : null,
	imgName    : "",
	isLoad     : false,
};

export default function BlogFields () {
	const [{ url, urlRegex, status, title, desc, shortDesc, editorState,
		seoTitle, seoDesc, tags, imgAlt, img, imgName, isLoad },
		setState] = useState (initialState);

	const onChange = (e) => {
        const {name, value} = e.target;

        if (name === 'url')
            if (urlValid (value))
                return setState (prevState => ({ ...prevState, [name]: value, 'urlRegex': true }));
        else return setState (prevState => ({ ...prevState, [name]: value, 'urlRegex': false }));

        setState (prevState => ({ ...prevState, [name]: value }));

    }

	const urlValid = (s) => {
		return (/[\w_-]+$/.test (s));
	}

	const handleImage = (e) => {
		const file   = e.target.files[0];
		const reader = new FileReader();
		reader.onloadend = () => {
			setState (prevState => ({ ...prevState, "imgName": file.name, "img": reader.result }));
			console.log ("img done");
		};
		reader.readAsDataURL (file);
	}

	const handleHashTags = (arr) => {
		setState (prevState => ({ ...prevState, 'tags': arr }));
	}

	const handleEditorState = (value) => {
		setState (prevState => ({ ...prevState, 'editorState': value }));
	}

	const clearState = () => {
		  setState ({...initialState});
	}

	const onSubmit = async () => {
		try {
			if (!urlRegex)
				return window.alert ("URL not acceptable!");

			if (!editorState)
				return window.alert ('Please write the content, in the editor, to post!');

			let edContent = draftToHtml (convertToRaw(editorState.getCurrentContent ()));

			if (edContent.trim () === "<p></p>")
				return window.alert ('Please write the content, in the editor, to post!');

			var data = {
				"url"        :url,
				"status"     :status,
				"title"      :title,
				"desc"       :desc,
				"short_desc" :shortDesc,
				"text"       :draftToHtml (convertToRaw(editorState.getCurrentContent ())),
				"seo_title"  :seoTitle,
				"seo_desc"   :seoDesc,
				"tags"       :tags,
				"img_alt"    :imgAlt,
				"img"        :img,
			};

			setState (prevState => ({ ...prevState, 'isLoad': true }));
			let resp    = await articleAdd (data);
			setState (prevState => ({ ...prevState, 'isLoad': false }));
			let respTxt = `Post www.overseas.one/blog/${resp.id} published!`;
			window.alert (respTxt);
			clearState ();

		}
		catch (err) {
			console.error (err);
			window.alert ("Please fill in the required fields.");
		}
	}

	if (isLoad === true)
		return (
			<p style={{margin: '50px 0 0 50px'}}><b>Loading...</b></p>
		);

	return (
		<>
			<MetaDataTop
				url={url}
				urlRegex={urlRegex}
				status={status}
				title={title}
				desc={desc}
				shortDesc={shortDesc}
				onChange={onChange}
			/>
			<Wysiwyg
				editorState={editorState}
				handleEditorState={handleEditorState}
			/>
			<MetaDataDown
				seoTitle={seoTitle}
				seoDesc={seoDesc}
				imgAlt={imgAlt}
				img={img}
				imgName={imgName}
				onChange={onChange}
				handleImage={handleImage}
				tags={tags}
				handleHashTags={handleHashTags}
			/>
			<Grid container spacing={1}>
				<Grid item xs={false} md={10} style={{backgroundColor: ''}}>
				</Grid>
				<Grid item xs={12} md={1} style={{margin: '20px 10px 20px 20px', display: 'flex', justifyContent: 'right'}}>
					<Button variant="contained" onClick={onSubmit}>Post</Button>
				</Grid>
			</Grid>
		</>
	);
}
